<template>
  <div id="modalSyncDataConfirm" class="modal fade" tabindex="-1">
    <div
      class="modal-dialog"
      :class="{ 'modal-full': !allDataSelected, 'modal-full': finishSync }"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Sincronizar Dados</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            :disabled="disableButton"
            @click="$emit('closeModal', true)"
          />
        </div>
        <form @submit.prevent="syncData">
          <div class="modal-body pb-1">
            <div
              v-if="allDataSelected && !disableButton && !finishSync"
              class="row"
            >
              <p>Confirma a sincronização dos dados selecionados?</p>
              <hr class="mb-1" />
              <label class="col-8 col-form-label" for="purge">
                Deseja limpar todos os dados?
              </label>
              <div class="col-4">
                <div class="form-check-horizontal">
                  <label class="form-check form-check-inline">
                    <input
                      type="checkbox"
                      id="purge"
                      class="form-check-input cp"
                      title="Sim"
                      value="true"
                      v-model="purge"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div v-if="allDataSelected && disableButton && !finishSync">
              <p>Os dados estão sendo sincronizados, por favor aguarde...</p>
            </div>
            <div v-if="allDataSelected && finishSync" class="row">
              <h5>Resultado:</h5>
              <p>{{ resultSync }}</p>
            </div>
            <div v-if="!allDataSelected">
              <p>Confirma a sincronização dos dados selecionados?</p>
              <div class="table-responsive mb-3">
                <table class="table table-sm table-bordered fs-sm">
                  <thead>
                    <tr>
                      <th>Código da Setença</th>
                      <th>Título</th>
                      <th>Status</th>
                      <th>Resultado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in dataSync" :key="data.codSentenca">
                      <td>{{ data.codSentenca }}</td>
                      <td>{{ data.titulo }}</td>
                      <td v-html="statusSincronizacaoLabel(data.status)" />
                      <td>{{ data.resultado }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Fechar"
              :disabled="disableButton"
              @click="$emit('closeModal', true)"
            >
              <span>Fechar</span>
            </button>
            <button
              v-if="!finishSync"
              type="submit"
              class="btn btn-dark"
              title="Confirmar"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                Sincronizando <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Confirmar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '@/utils/modal'
import { statusSincronizacaoLabel } from '@/utils/strings'

export default {
  name: 'SyncDataConfirmModal',

  props: {
    allDataSelected: {
      type: Boolean,
      required: true,
    },
    dataSync: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      disableButton: false,
      purge: false,
      finishSync: false,
      resultSync: '',
      statusSincronizacaoLabel,
    }
  },

  methods: {
    async syncData() {
      this.disableButton = true
      try {
        if (this.allDataSelected) {
          const response = await this.$store.dispatch('syncData', {
            allDataSelected: this.allDataSelected,
            purge: this.purge,
          })

          this.finishSync = true
          this.resultSync = response.data.Log
          this.$root.$refs.notification.success(response.message)
          this.disableButton = false
          return
        }

        await this.dataSync.reduce(async (prev, data) => {
          await prev

          data.status = 1

          const response = await this.$store.dispatch('syncData', {
            allDataSelected: this.allDataSelected,
            purge: this.purge,
            tableName: data.titulo,
          })

          data.status = 2
          data.resultado = response.data.Log

          this.$root.$refs.notification.success(
            `Sincronização da tabela ${data.titulo} concluída.`,
          )
        }, Promise.resolve())

        this.finishSync = true
        this.disableButton = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    showModal('modalSyncDataConfirm')
  },
}
</script>
